import { render, staticRenderFns } from "./SalesHotelReport.vue?vue&type=template&id=838d6da6&scoped=true"
import script from "./SalesHotelReport.vue?vue&type=script&lang=js"
export * from "./SalesHotelReport.vue?vue&type=script&lang=js"
import style0 from "./SalesHotelReport.vue?vue&type=style&index=0&id=838d6da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838d6da6",
  null
  
)

export default component.exports